import React, { useCallback, useEffect } from 'react';
import Header from '../../components/Header/Header';
import createDOMPurify from 'dompurify';
import useGetPageConfig from '../../hooks/useGetPageConfig';
import RefundPolicyMovioEN from './translations/en/RefundPolicy.html';
import RefundPolicyID from './translations/id/RefundPolicy_ID.html';
import RefundPolicyBG from './translations/bg/RefundPolicy_bg.html';

// import { isCreditCardPortal } from '../../constants/cc';
import { dashboardURL } from '../../constants/dashboardURL';
import { config, getHostname } from '../../constants/domainConfig';
import PageLoader from '../../components/Loaders/PageLoader';

const sanitize = (html) => {
    if (!window) return '';
    return createDOMPurify(window).sanitize(html);
};

const getRefundPolicyTranslated = (product) => {
    switch (product) {
        case 'nonton-tv':
            if (config.lang === 'id') {
                return RefundPolicyID;
            }
            return RefundPolicyMovioEN;
        case 'playnixzone':
            if (config.lang === 'bg') {
                return RefundPolicyBG;
            }
            return RefundPolicyMovioEN;
        default:
            return RefundPolicyMovioEN;
    }
};

const RefundPolicy = () => {
    const [loading, setLoading] = React.useState(false);
    const [html, setHTML] = React.useState('');
    const { product } = useGetPageConfig();

    const fetchHTML = useCallback(
        async (url) => {
            setLoading(true);
            try {
                const response = await fetch(url);
                if (response.ok) {
                    const html = await response.text();
                    setHTML(html);
                } else {
                    console.warn(`Failed to fetch external FAQ from ${url} (status: ${response.status}). Falling back to local version.`);
                    setHTML(getRefundPolicyTranslated(product)); // Fallback to local version if fetch fails
                }
            } catch (error) {
                console.error(`Error fetching external FAQ from ${url}:`, error);
                setHTML(getRefundPolicyTranslated(product)); // Fallback to local version if fetch fails
            } finally {
                setLoading(false);
            }
        },
        [product],
    );

    useEffect(() => {
        const url = new URL(dashboardURL);
        url.searchParams.append('pageType', 'terms');
        url.searchParams.append('subdomain', getHostname());
        url.searchParams.append('language', 'en'); // Only English is available as of now
        fetchHTML(url);
    }, [fetchHTML, product]);

    if (loading) return <PageLoader />;

    return (
        <>
            <Header forceHideHamburger />
            <div className="static-pages">
                <div dangerouslySetInnerHTML={{ __html: sanitize(html) }} />
            </div>
        </>
    );
};

export default RefundPolicy;
